export default __webpack_public_path__ + "static/subscribe-img1-3a701c24cee1722b35c1be542ad33885.png";